import PropTypes from 'prop-types';

import styles from './styles.module.scss';

export const FramerPage = ({ path }) => (
  <div className={styles.container}>
    <iframe
      src={`${process.env.REACT_APP_FRAMER_WEBSITE_URL}${path}`}
      title="Framer Embedded Page"
      className={styles.iframe}
    />

    {/* Above iframe has these links, but we need them under base page for verification purposes */}
    <div className={styles.hiddenFooter}>
      <a href={`${process.env.REACT_APP_FRAMER_WEBSITE_URL}privacy-policy`} target="_blank" rel="noreferrer">
        Privacy Policy
      </a>

      <a href={`${process.env.REACT_APP_FRAMER_WEBSITE_URL}terms-and-conditions`} target="_blank" rel="noreferrer">
        Terms and Conditions
      </a>
    </div>
  </div>
);

FramerPage.propTypes = {
  path: PropTypes.string,
};
